(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('[data-ma-exhibit]').forEach(exhibit => {
      if (exhibit.dataset.ready) return;
      exhibit.dataset.ready = 'true';
      const rail = exhibit.querySelector('[data-ma-rail]');
      const items = [...exhibit.querySelectorAll('[data-ma-exhibit-item]')];
      const buttons = [...exhibit.querySelectorAll('[data-ma-exhibit-select]')];
      const select = index => rail.scrollTo({left: index * rail.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      buttons.forEach((button, index) => button.addEventListener('click', () => select(index)));
      rail.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = Math.round(rail.scrollLeft / rail.clientWidth);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : Math.max(0, Math.min(items.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1)));
        select(next);
      });
      let scheduled = false;
      rail.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          const index = Math.round(rail.scrollLeft / rail.clientWidth);
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
          scheduled = false;
        });
      }, {passive:true});
    });
    root.querySelectorAll('.mx-col__fdisclosure').forEach(disclosure => {
      if (disclosure.dataset.ready) return;
      disclosure.dataset.ready = 'true';
      if (window.matchMedia('(max-width:749px)').matches && !location.search.includes('filter.')) disclosure.open = false;
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
